export const CHAT_SUGGESTIONS = [
  "Me partager les premières préoccupations des français",
  "Me partager les problématiques de mon territoire",
  "Questions fréquentes",
  "Me donner des idées d'actions pour ma commune",
] as const;

export type ParcoursId = 'candidate' | 'citizen';

export interface ParcoursConfig {
  id: ParcoursId;
  label: string;
  titre: string;
  phraseFinale: string;
  boutons: { emoji: string; label: string }[];
  hoverTexts?: Record<string, string>;
  tooltip?: string;
  description: string;
  subTitle?: string;
}

export const HOME_CONFIG = {
  description: 'Découvrez VictorIA, l\'assistante virtuelle qui vous accompagne dans votre projet de territoire.',
}

export const PARCOURS_CONFIG: Record<ParcoursId, ParcoursConfig> = {
  candidate: {
    id: 'candidate',
    label: 'Vous êtes élu.e / candidat.e aux élections municipales',
    titre: 'Bonjour, je suis VictorIA.',
    description: `Ensemble, identifions vos priorités, découvrons des initiatives locales et explorons des pistes durables pour votre projet de territoire.`,

    phraseFinale: 'Prêt(e) à faire de l\'écologie un pilier de votre projet de territoire, pour améliorer la qualité de vie et répondre aux attentes des habitants ?',
    boutons: [
      { emoji: '🎯', label: 'Explorer les priorités des Français' },
      { emoji: '💡', label: 'Trouver des idées pour votre commune' },
      { emoji: '🌟', label: 'S\'inspirer d\'autres communes' },
      { emoji: '❓', label: 'Voir les questions fréquentes' },
    ],
    hoverTexts: {
      'Explorer les priorités des Français': 'Me partager les premières préoccupations des Français',
      'Trouver des idées pour votre commune': 'Me partager les problématiques de mon territoire',
    },
    tooltip: 'Identifiez des propositions crédibles à inscrire dans votre programme',
    subTitle: 'Construisez un programme d\'actions concrètes pour votre commune.',
  },
  citizen: {
    id: 'citizen',
    label: 'Vous êtes citoyen.ne',
    titre: 'Bonjour, je suis VictorIA.',
    description: `Ensemble, identifions vos priorités, découvrons des initiatives locales et explorons des pistes durables pour votre territoire.`,

    phraseFinale: 'Prêt(e) à devenir acteur du changement dans votre commune ?',
    boutons: [
      { emoji: '🎯', label: 'Explorer les priorités des Français' },
      { emoji: '💡', label: 'Trouver des idées pour votre commune' },
      { emoji: '🌟', label: 'S\'inspirer d\'autres communes' },
      { emoji: '❓', label: 'Voir les questions fréquentes' },
    ],
    hoverTexts: {
      'Explorer les priorités des Français': 'Me partager les premières préoccupations des Français',
      'Trouver des idées pour votre commune': 'Me partager les problématiques de mon territoire',
    },
    tooltip: 'Trouvez comment agir pour votre territoire',
    subTitle: 'Découvrez des solutions et des initiatives inspirantes pour votre territoire.',
  },
}; 